<template>
  <page>
    <form>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-toolbar dense color="grey lighten-3" flat>
                <v-toolbar-title>Filters</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <message :messages="messages"></message>
                <v-layout row wrap>
                  <v-flex xs6 sm6>
                    <cal-picker v-model="form.contraJrnlDateFrom" :label="label.contraJrnlDateFrom" :data-vv-as="label.contraJrnlDateFrom" data-vv-name="form.contraJrnlDateFrom" :error-messages="errors.collect('form.contraJrnlDateFrom')" v-validate="doValidateDateFrom" :max="new Date()"/>
                  </v-flex>
                  <v-flex xs6 sm6>
                    <cal-picker v-model="form.contraJrnlDateTo" :label="label.contraJrnlDateTo" :data-vv-as="label.contraJrnlDateTo" data-vv-name="form.contraJrnlDateTo" :error-messages="errors.collect('form.contraJrnlDateTo')" v-validate="doValidateDateTo" :max="new Date()"/>
                  </v-flex>
                  <v-flex xs6 sm6>
                    <v-text-field v-model="form.jrnlNoFrom" :label="label.jrnlNoFrom" :error-messages="errors.collect('form.jrnlNoFrom')" data-vv-name="form.jrnlNoFrom" :data-vv-as="label.jrnlNoFrom" v-validate="doValidateJrnlNoFrom"></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6>
                    <v-text-field v-model="form.jrnlNoTo" :label="label.jrnlNoTo" :error-messages="errors.collect('form.jrnlNoTo')" data-vv-name="form.jrnlNoTo" :data-vv-as="label.jrnlNoTo" v-validate="doValidateJrnlNoTo"></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6>
                    <v-text-field v-model="form.branch" :label="label.branch" :error-messages="errors.collect('form.branch')" data-vv-name="form.branch" :data-vv-as="label.branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" readonly v-validate="'required'">
                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                        <v-icon color="info" @click="getHelpList('branch')"></v-icon>
                      </v-slide-x-reverse-transition>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6>
                   <v-text-field v-model="form.matchedBy" :label="label.matchedBy" :error-messages="errors.collect('form.matchedBy')" data-vv-name="form.matchedBy" :data-vv-as="label.matchedBy" append-icon="mdi-magnify" @click:append="getHelpList('matchedBy')" readonly v-validate="'required'">
                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                      <v-icon color="info" @click="getHelpList('matchedBy')"></v-icon>
                    </v-slide-x-reverse-transition>
                   </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox color="primary" :label="label.includeJrnlPrvPrintedAE" v-model="form.includeJrnlPrvPrintedAE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox color="primary" :label="label.pageBreakByBranchAE" v-model="form.pageBreakByBranchAE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox color="primary" :label="label.runTimeParamAE" v-model="form.runTimeParamAE"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 class="pt-3">
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    {{label.export}}
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="form.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{format.label}}</span>
                      <v-icon :color="format.color">{{format.icon}}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
    <v-dialog v-model="HelpList" width="900px" persistent>
      <help-list :apiURI="apiURI" :mode="mode" :param="param" :defAll="defAll" :boolRefresh="HelpList" @close="doClose" @doAssign="doAssign($event)"></help-list>
    </v-dialog>

    <v-dialog v-model="promptWarnDialog" width="50%" persistent>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Warning
            <v-spacer></v-spacer>
            <v-btn text icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12>
                    {{warnMsg}}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import routeMixin from '@/mixins/route'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import HelpList from '@/components/core/common/dialog/HelpList'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import isAfter from 'date-fns/isAfter'
import { removeTime, formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      label: {
        contraJrnlDateFrom: 'Contra Journal Date From',
        contraJrnlDateTo: 'Contra Journal Date To',
        jrnlNoFrom: 'Journal Nos From',
        jrnlNoTo: 'Journal Nos To',
        branch: 'Branch',
        matchedBy: 'Matched By',
        includeJrnlPrvPrintedAE: 'Include those Journals previously printed',
        pageBreakByBranchAE: 'Page break by Branch',
        runTimeParamAE: 'Run-time parameters',
        export: 'Export'
      },
      form: {
        contraJrnlDateFrom: '',
        contraJrnlDateTo: '',
        jrnlNoFrom: '',
        jrnlNoTo: '',
        branch: 'All',
        matchedBy: 'All',
        includeJrnlPrvPrintedAE: false,
        pageBreakByBranchAE: false,
        runTimeParamAE: true,
        format: 'PDF'
      },
      mode: '',
      param: '',
      apiURI: '',
      defAll: true,
      HelpList: false,
      menu: {},
      supportedFormat: [],
      submitting: false,
      promptWarnDialog: false,
      warnMsg: 'Must update Contra Journal Date Range OR Journal No. Range.'
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.matchedAcctTrans
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      this.param = ''
      this.defAll = true
      if (fieldName === 'branch') {
        this.apiURI = this.$store.state.commons.menu.getBranchList
        this.param = this.form.branch
      } else if (fieldName === 'matchedBy') {
        this.apiURI = this.$store.state.commons.menu.getAcctMatchedByList
        this.param = this.form.matchedBy
      }
      this.HelpList = true
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch': this.form.branch = ''
          this.form.branch = Obj.finalSelectedItems.toString()
          break
        case 'matchedBy': this.form.matchedBy = ''
          this.form.matchedBy = Obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.HelpList = false
    },
    closeDialog() {
      this.promptWarnDialog = false
    },
    async getJrnlNo() {
      const apiUrl = this.menu.getJrnlNo
      if (apiUrl) {
        try {
          const expand = {
            tranDateFrom: this.form.contraJrnlDateFrom,
            tranDateTo: this.form.contraJrnlDateTo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.form.jrnlNoFrom = data.contralJrnlFrom
            this.form.jrnlNoTo = data.contralJrnlTo
          }
        } catch (err) {
          this.$toast.error('Error retrieving contral journal no.')
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doExport() {
      if (this.form.includeJrnlPrvPrintedAE === true && this.form.contraJrnlDateFrom === '' && this.form.contraJrnlDateTo === '' &&
        this.form.jrnlNoFrom === '' && this.form.jrnlNoTo === '') {
        this.promptWarnDialog = true
      } else {
        this.resetMessages()
        this.$validator.validateAll().then(result => {
          if (result) {
            this.processExport()
          }
        })
      }
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let messageFilters = clone(this.form)
          if (messageFilters.contraJrnlDateFrom !== '') {
            messageFilters.contraJrnlDateFrom = formatDisplayDate(messageFilters.contraJrnlDateFrom)
          }
          if (messageFilters.contraJrnlDateTo !== '') {
            messageFilters.contraJrnlDateTo = formatDisplayDate(messageFilters.contraJrnlDateTo)
          }
          await this.$http.post(apiURI, messageFilters)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    doValidateDateFrom() {
      const today = new Date()
      if ((this.form.contraJrnlDateFrom !== '' && this.form.contraJrnlDateTo !== '') &&
        (this.form.contraJrnlDateFrom !== undefined && this.form.contraJrnlDateTo !== undefined)) {
        return 'required|valMaxDate:' + today
      } else if ((this.form.contraJrnlDateFrom === '' && this.form.contraJrnlDateTo !== '') ||
        (this.form.contraJrnlDateFrom === undefined && this.form.contraJrnlDateTo !== undefined)) {
        return 'required'
      } else {
        return ''
      }
    },
    doValidateDateTo() {
      if ((this.form.contraJrnlDateTo !== '' && this.form.contraJrnlDateFrom !== '') &&
       (this.form.contraJrnlDateTo !== undefined && this.form.contraJrnlDateFrom !== undefined)) {
        return 'required|valMinDate:' + this.form.contraJrnlDateFrom
      } else if ((this.form.contraJrnlDateTo === '' && this.form.contraJrnlDateFrom !== '') ||
        (this.form.contraJrnlDateTo === undefined && this.form.contraJrnlDateFrom !== undefined)) {
        return 'required'
      } else {
        return ''
      }
    },
    doValidateJrnlNoFrom() {
      if (this.form.jrnlNoFrom !== '') {
        if (this.form.jrnlNoTo !== '') {
          return 'entry|numeric|valJrnlNoFrom:' + this.form.jrnlNoTo
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    doValidateJrnlNoTo() {
      if (this.form.jrnlNoTo !== '') {
        if (this.form.jrnlNoFrom !== '') {
          return 'entry|numeric|valJrnlNoTo:' + this.form.jrnlNoFrom
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        this.form.format = value[0].value
      }
    },
    'form.contraJrnlDateTo': function() {
      if (this.form.contraJrnlDateFrom !== '' && this.form.contraJrnlDateTo !== '' &&
      this.form.contraJrnlDateFrom !== undefined && this.form.contraJrnlDateTo !== undefined) {
        this.getJrnlNo()
      }
    }
  },
  created() {
    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Cannot be later than System Date'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Date'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
    this.$validator.extend('valJrnlNoFrom', {
      getMessage(field, args) {
        return 'Cannot be later than Journal No To'
      },
      validate(value, args) {
        if (Number(value) > Number(args[0])) {
          return false
        } else return true
      }
    })
    this.$validator.extend('valJrnlNoTo', {
      getMessage(field, args) {
        return 'Cannot be ealier than Journal No From'
      },
      validate(value, args) {
        if (Number(value) < Number(args[0])) {
          return false
        } else return true
      }
    })
  },
  mounted() {
    this.doInit()
  },
  components: {
    HelpList
  },
  mixins: [
    MessageMixin,
    routeMixin,
    commonAjaxMixin
  ]
}

</script>
